<mat-form-field class="full-width">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <input
    #inputField
    matInput
    [placeholder]="placeholder"
    [formControl]="form"
    [matAutocomplete]="auto"
    [disabled]="disabled"
    (focus)="onInputFocus()"
  />

  <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="false">
    <mat-option disabled *ngIf="loading">
      <mat-spinner diameter="20"></mat-spinner>
      {{ "loading" | translate }}
    </mat-option>
    <mat-option
      *ngFor="let item of filteredItems"
      class="checkbox-option"
      (click)="$event.stopPropagation()"
    >
      <mat-checkbox
        [checked]="isItemSelected(item)"
        (change)="toggleSelection(item)"
        (click)="$event.stopPropagation()"
      >
        {{ item[displayProperty] }}
        <ng-container
          *ngIf="secondaryDisplayProperty && item[secondaryDisplayProperty]"
        >
          - {{ item[secondaryDisplayProperty] }}
        </ng-container>
      </mat-checkbox>
    </mat-option>
    <mat-option disabled *ngIf="!loading && filteredItems.length === 0">
      {{ "no-results-found" | translate }}
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="required && selectedItems.length === 0">
    {{ "field-required" | translate }}
  </mat-error>
</mat-form-field>

<div *ngIf="selectedItems.length > 0" class="selected-items-container">
  <mat-table [dataSource]="dataSource" appTableStripedHorizontal>
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef>
        {{ label || displayProperty }}
      </mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item[displayProperty] }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="secondary" *ngIf="secondaryDisplayProperty">
      <mat-header-cell *matHeaderCellDef>
        {{ secondaryLabel || secondaryDisplayProperty }}
      </mat-header-cell>
      <mat-cell *matCellDef="let item">
        {{ item[secondaryDisplayProperty] }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-column">
      </mat-header-cell>
      <mat-cell *matCellDef="let item" class="actions-column">
        <button
          mat-icon-button
          type="button"
          (click)="remove(item)"
          [disabled]="disabled"
          [attr.aria-label]="'remove' | translate"
        >
          <mat-icon fontIcon="Bosch-Ic-delete"></mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</div>
